var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<h1 class=\"account-header\" translate=\"MEMBER.UPCOMING_BOOKINGS.HEADING\">\n</h1>\n<div bb-member-upcoming-bookings member=\"client\" not-loaded=\"notLoaded\" set-loaded=\"setLoaded\">\n</div>";
var id1="member/_templates/steps/upcoming_bookings.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/member/_templates/steps/upcoming_bookings.html
// module id = 1172
// module chunks = 0